function ErrorPage() {

  return (
    <>
      <div className="container">
        <h1 className="text-center p-2">Oooops</h1>
        <p className="text-center p-2">sorry, un expected Error has occured.</p>
      </div>
    </>
  );
}

export { ErrorPage };
